import { css, FlattenSimpleInterpolation } from "styled-components";
import { TextType } from "./interface";

export const TextStyleByType: {
  [key in TextType]: FlattenSimpleInterpolation;
} = {
  [TextType.H1]: css`
    font-size: 32rem;
    line-height: 38px;
    font-weight: 600;
  `,
  [TextType.H2]: css`
    font-size: 2.6rem;
    line-height: 30px;
    font-weight: 600;
  `,
  [TextType.H3]: css`
    font-size: 2.4rem;
    line-height: 24px;
    font-weight: 600;
  `,
  [TextType.H4]: css`
    font-size: 2.2rem;
    line-height: 24px;
  `,
  [TextType.H5]: css`
    font-size: 2rem;
    line-height: 24px;
    font-weight: 400;
  `,
  [TextType.H6]: css`
    font-size: 1.8rem;
    font-weight: 600;
  `,
  [TextType.BODY]: css`
    font-size: 1.6rem;
    line-height: 24px;
  `,
  [TextType.BODY2]: css`
    font-size: 1.4rem;
    line-height: 21px;
  `,
  [TextType.SUB_BODY]: css`
    font-size: 1.2rem;
    line-height: 21px;
  `,
};
